import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import MdaeTextBox from "../../common_components/common_widgets/text-box";
import MdaeSelectBox from "../../common_components/common_widgets/select-box";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import MdaeFileUploader from "../../common_components/common_widgets/file-uploader";
import {
  REMOVE_SELECTED_FILE,
  SAVE_DOCUMENT_UPLOAD_GRID_DATA,
  SET_DOCUMENT_DATA,
  SET_DOCUMENT_DATA_TO_SAVE,
  SET_DOCUMENT_POPUP_MODE,
  SET_DOCUMENT_UPLOAD_PROGRESS,
  SET_SELECTED_ROW_DATA,
  SET_SINGLE_DOCUMENT_DATA,
  TOGGLE_EDIT_DOCUMENT_POPUP,
  addCommonProperties,
  documentUploadDatagridKeyExpr,
  formatDocumentToSaveObjectForUpdate,
  initialDocumentDataToSave,
} from "./reducers/document-management-reducer";
import { useDispatch, useSelector } from "react-redux";
import { EDIT_DOCUMENT } from "./services/edit-document";
import { DataGrid, Validator } from "devextreme-react";
import { CustomRule, RequiredRule } from "devextreme-react/validator";
import { actions as asyncActions } from "async-ops";
import { callOperation, actions } from "async-ops";
import { HIDE_LOADER, SHOW_LOADER } from "../mdae-common-reducer";
import { SAVE_USER_DOCUMENTS } from "./services/save-document";
import * as documentUploadFramework from "../../utils/document-upload-framework";
import mdaeNotfy, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_components/common_widgets/toast/notify";
import WaitTimeMessageModal from "./wait-time-message-modal";
import { GET_DOCUMENTS } from "./services/get-documents";
import { bindActionCreators } from "redux";
import MdaeCheckBox from "../common_widgets/check-box";
import { GET_DOCUMENT_MANAGEMENT_CONFIG } from "./services/get-document-management-configurations";
import { initiateOCRPolling } from "../case-search/use-ocr-polling";
import {
  SET_CASE_SEARCH_DOCUMENT_DATA,
  SET_S3_OBJECT_NAME,
} from "../case-search/reducers/case-search-reducer";
import { PDFDocument } from "pdf-lib";
import mdaeNotify from "../../common_components/common_widgets/toast/notify";
import dxFileUploader, { ValueChangedEvent } from "devextreme/ui/file_uploader";
import {
  Button,
  Column,
  Editing,
  Lookup,
  Pager,
  Paging,
  PatternRule as PatternRuleDatagrid,
  CustomRule as CustomRuleDataGrid,
} from "devextreme-react/data-grid";
import dxDataGrid from "devextreme/ui/data_grid";
import { first } from "lodash";
import CircularProgressWithLabel from "../common_widgets/cIrcular-progress-indicator";
import MdaeTabPanel from "../common_widgets/tab-panel";
import { Item } from "devextreme-react/tab-panel";
import DocumentManagement, { USER_ACTION_MODE } from "./component";
import { ATTACH_DOCUMENT } from "./services/attach-documents";
import { FG_DOCUMENT_MANAGEMENT, FG_EXTERNAL_USER_TASK_EDITING, hasAnyFeatureGroupAccess } from "../user-permissions-helper";
export const DOCUMENT_POPUP_MODE = {
  UPLOAD: "UPLOAD",
  EDIT: "EDIT",
  OCR_UPLOAD: "OCR_UPLOAD",
};
const setUploadProgress = (
  dispatch,
  documentUploadDatagridKeyExpr,
  uploadProgress
) => {
  dispatch({
    type: SET_DOCUMENT_UPLOAD_PROGRESS,
    data: {
      documentUploadDatagridKeyExpr,
      uploadProgress,
    },
  });
};
const readFile = (file) => {
  return new Promise<ArrayBuffer | string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);

    reader.readAsArrayBuffer(file);
  });
};
const documentValidationMessage =
  "This document contains invalid special characters. Please rename the document by removing the special characters or using one of the following: & $ @ = ! - _ . ) ( '";
export const isDocumentNameValid = (documentName) => {
  var regexp = /^[a-zA-Z0-9 &$@=!\-_.)(']*$/;
  return regexp.test(documentName);
};

const getNumPages = (file) => {
  return new Promise<number>((resolve, reject) => {
    readFile(file)
      .then((arrayBuffer) => {
        PDFDocument.load(arrayBuffer)
          .then((pdf) => {
            resolve(pdf.getPageCount());
          })
          .catch(() => {
            reject(null);
          });
      })
      .catch(() => {
        reject(null);
      });
  });
};
function getReleventFileSizeUnitFromBytes(fileSizeInBytes) {
  const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
  const fileSizeInKB = fileSizeInBytes / 1024;
  let fileSizeDisplayName = "";
  if (fileSizeInMB >= 1) {
    fileSizeDisplayName = fileSizeInMB.toFixed(2) + " MB";
  } else {
    if (fileSizeInKB >= 1) {
      fileSizeDisplayName = fileSizeInKB.toFixed(2) + " KB";
    } else {
      fileSizeDisplayName = fileSizeInBytes.toFixed(2) + " B";
    }
  }
  return fileSizeDisplayName;
}
function getFileExtension(filename) {
  return filename.split(".").pop();
}
const documentValidationGroup = "documentValidationGroup";
export const toggleEditDocumentPopupVisible = (
  dispatch,
  isVisible,
  title = "",
  mode = "",
  data: any = { ...initialDocumentDataToSave }
) => {
  dispatch({
    type: SET_DOCUMENT_POPUP_MODE,
    data: {
      documentPopupMode: mode,
    },
  });
  dispatch({
    type: TOGGLE_EDIT_DOCUMENT_POPUP,
    data: {
      ...data,
      isEditDocumentPopupVisible: isVisible,
      editDocumentPopupTitle: title,
      editDocumentPopupMode: mode,
      attachedLevelName: data.attachedLevelName,
      attachedLevelId: data.attachedLevelId,
    },
  });
  if (
    [DOCUMENT_POPUP_MODE.EDIT, DOCUMENT_POPUP_MODE.OCR_UPLOAD].includes(mode)
  ) {
    dispatch({
      type: SET_DOCUMENT_DATA,
      data: {
        documentDataToSave: [
          {
            ...data,
            documentName: data.documentName,
            documentCategoryId: data.documentCategoryId,
            saveToDocumentManagement: data.saveToDocumentManagement,
            attachedLevelId: data.attachedLevelId,
            attachedLevelName: data.attachedLevelName,
          },
        ],
      },
    });
  } else {
    dispatch({
      type: SET_DOCUMENT_DATA,
      data: {
        documentDataToSave: [],
      },
    });
  }
};

const documentFieldValueChangeEvent = (dispatch, name, value) => {
  dispatch({
    type: SET_SINGLE_DOCUMENT_DATA,
    data: {
      [name]: value,
    },
  });
};

function isPopupCloseSafe(state: any): any {
  return (
    state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.OCR_UPLOAD ||
    state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.EDIT ||
    (state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.UPLOAD &&
      state["documentManagementReducer"].documentDataToSave.every(
        (x) =>
          x.uploadProgress === 100 ||
          x.uploadProgress === -1 ||
          x.uploadProgress === null
      ))
  );
}

interface IEditDocumentPopup {
  doNotRefreshDataGrid?: boolean;
  taskAttachmentLevel?: string;
  parentAttachmentLevelName?: string;
  parentAttachmentLevelId?: string;
  uniqueId?: string;
}
const EditDocumentPopup: React.FC<IEditDocumentPopup> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const documentUploaderInstance: dxFileUploader = dxFileUploader.getInstance(
    document.getElementById("btnFileUploader")
  ) as dxFileUploader;
  const documentDataGridInstance = dxDataGrid.getInstance(
    document.getElementById("grdDocumentUpload")
  ) as dxDataGrid;

  const editDocumentPopupTitle = useSelector(
    (state) => state["documentManagementReducer"].editDocumentPopupTitle
  );
  const isPopupModeUploadToOCR = useSelector(
    (state: any) =>
      state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.OCR_UPLOAD
  );
  const isDocumentPopupSafeToClose: boolean = useSelector((state: any) =>
    isPopupCloseSafe(state)
  );
  const documentDataToSave: Array<typeof initialDocumentDataToSave> = useSelector(
    (state: any) => state["documentManagementReducer"].documentDataToSave
  );
  const attachedLevelId = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelId
  );
  const attachedLevelName = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelName
  );
  const includeNonAuditLevelDocumentInd = useSelector(
    (state) =>
      state["documentManagementReducer"].includeNonAuditLevelDocumentInd
  );
  const eaAuditId = useSelector(
    (state) => state["auditPropertiesReducer"]?.auditPropertiesData?.eaAuditId
  );
  const documentAttachmentLevelEnums = useSelector(
    (state) => state["documentManagementReducer"].documentAttachmentLevels
  );
  const clientId = useSelector(
    (state: any) => state["mdaeNavigationBarReducer"]?.currentUser?.clientId
  );
  const isEditDocumentPopupVisible = useSelector(
    (state: any) => state["documentManagementReducer"].isEditDocumentPopupVisible
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser
  );
  const hasExtrnlUserTaskEditFg = useMemo(
    () =>
      hasAnyFeatureGroupAccess(
        [FG_EXTERNAL_USER_TASK_EDITING],
        currentUser
      ),
    [currentUser]
  );

  const editDocumentPopupMode = useSelector(
    (state: any) => state["documentManagementReducer"].editDocumentPopupMode
  );
  const selectedRowsData = useSelector(
    (state: any) => state["documentManagementReducer"].selectedRowsData
  );

  if (isPopupModeUploadToOCR) allowedFilesMap = { ".pdf": "application/pdf" };

  const documentPopupMode = useSelector(
    (state: any) => state["documentManagementReducer"].documentPopupMode
  );
  const isModeTaskUpload =
    attachedLevelName === "TS" &&
    documentPopupMode === DOCUMENT_POPUP_MODE.UPLOAD;

  const setSelectedRowsData = useCallback((selectedRowsData) => {
    dispatch({ type: SET_SELECTED_ROW_DATA, data: { selectedRowsData } });
  }, []);

  const uploadDocumentCount = useSelector(
    (state: any) =>
      state["documentManagementReducer"].documentDataToSave?.length ?? 0
  );
  const selctedAttachItemCount =
    (selectedRowsData?.length ?? 0) + uploadDocumentCount;

  const areAllDocumentsUploaded: boolean = useSelector(
    (state: any) =>
      state.documentManagementReducer.editDocumentPopupMode ===
        DOCUMENT_POPUP_MODE.UPLOAD &&
      state["documentManagementReducer"].documentDataToSave?.length > 0 &&
      state["documentManagementReducer"].documentDataToSave.every(
        (x) => x.uploadProgress === 100
      ) &&
      (selectedRowsData?.length ?? 0) === 0
  );
  const disableMyComputerSelection =
    isPopupModeUploadToOCR && (selectedRowsData?.length ?? 0) > 0;
  const disableGridSelection =
    isPopupModeUploadToOCR &&
    (documentDataToSave?.length ?? 0) > 0 &&
    first(documentDataToSave).selectedFile != null;

  useEffect(() => {
    if (areAllDocumentsUploaded)
      toggleEditDocumentPopupVisible(dispatch, false);
  }, [areAllDocumentsUploaded, editDocumentPopupMode]);

  useEffect(() => {
    if(isEditDocumentPopupVisible){
      setSelectedRowsData([]);
    }
  }, [isEditDocumentPopupVisible])

  const refreshDocumentList = useCallback(() => {
    asyncAction.asyncOperationStart(GET_DOCUMENTS, {
      attachedLevelId: attachedLevelId,
      attachedLevelName: attachedLevelName,
      showForCoderReviewInd: includeNonAuditLevelDocumentInd,
      isManagerView: false,
      uniqueId: props.uniqueId,
    });
  }, [attachedLevelId, attachedLevelName, includeNonAuditLevelDocumentInd]);

  const attachDocuments = useCallback(() => {
    dispatch({ type: SHOW_LOADER });
    const documents: any[] = selectedRowsData.map((document) => {
      return {
        attachedLevelId: attachedLevelId,
        attachedLevelName: attachedLevelName,
        documentId: document.documentId,
        documentName: document.documentName,
        originalFileName: document.originalFileName,
        s3ObjectName: document.s3ObjectName,
        tags: {
          clientId: clientId.toString(),
        },
        ocrMetricTrackingData: {
          pageCount: 0,
          eaAuditId: 0,
        },
      };
    });

    let documentAtachPromises = [];
    if (documents?.length > 0) {
      documents.forEach((document) => {
        if (isPopupModeUploadToOCR) {
          document.sendDocumentToOCR = true;
          document.attachedLevelName =
            documentAttachmentLevelEnums.externalAuditOCR;
          document.ocrMetricTrackingData = {
            pageCount: 0,
            eaAuditId,
          };
        }
        const documentAttachPromise = callOperation(
          ATTACH_DOCUMENT,
          document
        ).then((response) => {
          mdaeNotify({
            message: document.documentName + " attached successfully!",
            messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
          });
          return response;
        });
        documentAtachPromises.push(documentAttachPromise);
      });
    }

    return Promise.all(documentAtachPromises).then((responses) => {
      dispatch({ type: HIDE_LOADER });
      if (!props.doNotRefreshDataGrid) refreshDocumentList();
      if (isPopupModeUploadToOCR) {
        const attachResponse = first(responses);
        dispatch({
          type: SET_S3_OBJECT_NAME,
          data: attachResponse.data,
        });
        initiateOCRPolling(dispatch, asyncAction, {
          s3ObjectName: attachResponse.data,
        });
      }
      setSelectedRowsData([]);
    });
  }, [
    attachedLevelName,
    attachedLevelId,
    selectedRowsData,
    isDocumentPopupSafeToClose,
    documentAttachmentLevelEnums,
    isPopupModeUploadToOCR,
    documentDataToSave,
  ]);
  const uploadDocuments = useCallback(() => {
    if (documentPopupMode === DOCUMENT_POPUP_MODE.EDIT) {
      if (first(documentDataToSave).documentName) {
        callOperation(
            EDIT_DOCUMENT,
            formatDocumentToSaveObjectForUpdate(first(documentDataToSave))
          ).then((response)=>{
            if(!response.isEdited){
              mdaeNotify({
                message:response.error,
                messageType: NOTIFY_MESSAGE_TYPE.ERROR,
              })
            }
            toggleEditDocumentPopupVisible(dispatch, false);
          })       
        }
    } else documentUploaderInstance.upload();
  }, [
    documentUploaderInstance,
    documentPopupMode,
    documentDataToSave,
    documentDataGridInstance,
  ]);

  const onDocumentPopupSaveButtonClick = useCallback(
    (params) => {
      let saveChangesPromise = Promise.resolve();
      if (documentDataGridInstance?.hasEditData()) {
        saveChangesPromise = documentDataGridInstance?.saveEditData();
      }
      saveChangesPromise.then(() => {
        if (!params.validationGroup) return;
        let result = null;
        if (params.validationGroup) result = params.validationGroup.validate();
        if (result && result.isValid) {
          let documentSavePromise = Promise.resolve();
          if (isModeTaskUpload || isPopupModeUploadToOCR) {
            if(uploadDocumentCount > 0 && first(documentDataToSave)?.selectedFile != null)
              uploadDocuments();
            if ((selectedRowsData?.length ?? 0) > 0)
              documentSavePromise = attachDocuments();
          } else {
            uploadDocuments();
          }
          documentSavePromise.then(() => {
            if (
              uploadDocumentCount === 0 ||
              first(documentDataToSave)?.selectedFile == null
            )
              toggleEditDocumentPopupVisible(dispatch, false);
          });
        } else{
          result.brokenRules[0]?.validator?.focus();
          if (selctedAttachItemCount > 0)
            mdaeNotify({
              message: "Please remove selected unsupported/invalid file(s)",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
          else if (selctedAttachItemCount === 0)
            mdaeNotify({
              message: "Please Select at least one file",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
        }
      });
    },
    [
      isModeTaskUpload,
      attachDocuments,
      uploadDocuments,
      areAllDocumentsUploaded,
      isPopupModeUploadToOCR,
    ]
  );
  const documentFieldValueChangeHandler = useCallback((e) => {
    documentFieldValueChangeEvent(
      dispatch,
      e.component.option("name"),
      e.value
    );
  }, []);

  const getSamplePopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          isDocumentPopupSafeToClose &&
            toggleEditDocumentPopupVisible(dispatch, false);
        }}
      >
        {editDocumentPopupTitle}
      </MdaePopupTitle>
    );
  };

  return (
    <>
      <>
        <MdaePopup
          deferRendering={false}
          height={
            isModeTaskUpload ||
            isPopupModeUploadToOCR ||
            documentPopupMode === DOCUMENT_POPUP_MODE.UPLOAD
              ? 500
              : 320
          }
          width={isModeTaskUpload || isPopupModeUploadToOCR ? 950 : 600}
          mdaeTitleRender={getSamplePopupTitle}
          mdaeDataUpdaterConfig={[
            {
              actionType: TOGGLE_EDIT_DOCUMENT_POPUP,
              reducerName: "documentManagementReducer",
              widgetOptionBindings: {
                visible: "isEditDocumentPopupVisible",
                mdaePopupTitle: "editDocumentPopupTitle",
              },
            },
          ]}
          mdaeContentRender={() => {
            return (
              <div className="mdae-document-uploader-popup-content">
                <MdaePopupContent>
                  {(isModeTaskUpload || isPopupModeUploadToOCR) && !hasExtrnlUserTaskEditFg ? (
                    <>
                      <MdaeTabPanel>
                        <Item title={"My Computer"}>
                          <div
                            className={
                              disableMyComputerSelection ? "disable-ui" : ""
                            }
                          >
                            <EditOrAttachDocument {...props} />
                          </div>
                        </Item>
                        <Item title={"Document Management"}>
                          <div
                            className={disableGridSelection ? "disable-ui" : ""}
                          >
                            <DocumentManagement
                              hasAuditViewAccess={true}
                              isManagerView={false}
                              doNotLoadDatasourcesInd={true}
                              showForCoderReviewInd={false}
                              isBulkDwonloadVisible={false}
                              attachedLevelId={props.parentAttachmentLevelId}
                              attachedLevelName={
                                props.parentAttachmentLevelName
                              }
                              doNotLoadEditDocumentPopup={true}
                              isIncludeNonAuditLevelDocumentCheckBoxVisible={
                                true
                              }
                              isFromCaseDetails={true}
                              isViewOnlyGrid={true}
                              userActionMode={
                                isPopupModeUploadToOCR
                                  ? USER_ACTION_MODE.SMART_SCAN_SINGLE_SELECTION
                                  : USER_ACTION_MODE.MULTIPLE_SELECTION
                              }
                              setSelectedRowData={setSelectedRowsData}
                              selectedRowsData={selectedRowsData}
                              height={"350"}
                            />
                          </div>
                        </Item>
                      </MdaeTabPanel>
                    </>
                  ) : (
                    <EditOrAttachDocument {...props} />
                  )}
                </MdaePopupContent>
              </div>
            );
          }}
          mdaeFooterRender={() => {
            return (
              <MdaePopupFooter>
                <MdaePopupFooterStartButtons>
                  <MdaeButton
                    disabled={!isDocumentPopupSafeToClose}
                    id={"pnlEditDocumentSecondaryBtn"}
                    role={"secondary"}
                    validationGroup="documentValidationGroup"
                    onClick={(e) => {
                      e.validationGroup?.reset();
                      toggleEditDocumentPopupVisible(dispatch, false);
                    }}
                  >
                    Cancel
                  </MdaeButton>
                </MdaePopupFooterStartButtons>
                <MdaePopupFooterEndButtons>
                  <MdaeButton
                    disabled={!isDocumentPopupSafeToClose}
                    id={"pnlEditDocumentPrimaryBtn"}
                    role={"primary"}
                    onClick={onDocumentPopupSaveButtonClick}
                    validationGroup="documentValidationGroup"
                  >
                    {getSubmitButtonText(
                      isPopupModeUploadToOCR,
                      selctedAttachItemCount,
                      isModeTaskUpload
                    )}
                  </MdaeButton>
                </MdaePopupFooterEndButtons>
              </MdaePopupFooter>
            );
          }}
        ></MdaePopup>
        <WaitTimeMessageModal />
      </>
    </>
  );
};

const getSubmitButtonText = (
  isPopupModeUploadToOCR,
  selctedAttachItemCount,
  isModeTaskUpload
) => {
  if (isPopupModeUploadToOCR) return "Scan";
  if (isModeTaskUpload && selctedAttachItemCount > 0)
    return "Attach " + selctedAttachItemCount + " Document(s)";
  else if(isModeTaskUpload) return "Attach";
  else return "Save";
};

let allowedFilesMap: any = {
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpeg",
  ".png": "image/png",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".doc": "application/msword",
  ".docm": "application/vnd.ms-word.document.macroEnabled.12",
  ".dot": "application/msword",
  ".dotm": "application/vnd.ms-word.template.macroEnabled.12",
  ".dotx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  ".rtf": "application/rtf",
  ".xml": "application/xml",
  ".wps": "application/vnd.ms-works",
  ".xps": "application/vnd.ms-xpsdocument",
  ".pdf": "application/pdf",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".txt": "text/plain",
  ".xlsm": "application/vnd.ms-excel.sheet.macroEnabled.12",
  ".xlsb": "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  ".xltx":
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  ".xltm": "application/vnd.ms-excel.template.macroEnabled.12",
  ".xls": "application/vnd.ms-excel",
  ".xlt": "application/vnd.ms-excel",
  ".xlam": "application/vnd.ms-excel.addin.macroEnabled.12",
  ".xla": "application/vnd.ms-excel.addin",
  ".xlw": "application/vnd.ms-excel",
  ".xlr": "application/vnd.ms-works",
  ".csv": "text/csv",
  ".tiff": "image/tiff",
  ".tif": "image/tiff",
};

const EditOrAttachDocument: FC<IEditDocumentPopup> = (props) => {
  const [documentUploaderInstance, setDocumentUploaderInstance] = useState<
    dxFileUploader
  >(null);
  const [documentDataGridInstance, setDocumentDataGridInstance] = useState<
    dxDataGrid
  >(null);
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const ocrDocumentData = useSelector(
    (state: any) => state.caseSearchReducer.ocrDocumentData
  );
  const eaAuditId = useSelector(
    (state) => state["auditPropertiesReducer"]?.auditPropertiesData?.eaAuditId
  );
  const attachedLevelName = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelName
  );
  const attachedLevelId = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelId
  );
  const isPopupModeUploadToOCR = useSelector(
    (state: any) =>
      state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.OCR_UPLOAD
  );
  const documentCategoryList = useSelector(
    (state) => state["documentManagementReducer"].documentCategoryList
  );
  const documentAttachmentLevelEnums = useSelector(
    (state) => state["documentManagementReducer"].documentAttachmentLevels
  );
  const currentSelectedRowData = useSelector((state) =>
    first<any>(state["documentManagementReducer"].documentDataToSave)
  );
  const includeNonAuditLevelDocumentInd = useSelector(
    (state) =>
      state["documentManagementReducer"].includeNonAuditLevelDocumentInd
  );
  const taskAttachLevelEnums = useSelector(
    (state: any) => state["userTaskListReducer"].attachLevelEnums
  );

  const documentPopupMode = useSelector(
    (state: any) => state["documentManagementReducer"].documentPopupMode
  );
  const clientId = useSelector(
    (state: any) => state["mdaeNavigationBarReducer"]?.currentUser?.clientId
  );
  const documentDataToSave: Array<typeof initialDocumentDataToSave> = useSelector(
    (state: any) => state["documentManagementReducer"].documentDataToSave
  );

  const isDocumentPopupSafeToClose: boolean = useSelector((state: any) =>
    isPopupCloseSafe(state)
  );

  const selectedRowsData = useSelector(
    (state: any) => state["documentManagementReducer"].selectedRowsData
  );
  const uploadDocumentCount = useSelector(
    (state: any) =>
      state["documentManagementReducer"].documentDataToSave?.length ?? 0
  );
  const selctedAttachItemCount =
    (selectedRowsData?.length ?? 0) + uploadDocumentCount;

  const totalDocumentSpaceAvailable = useSelector(
    (state) => state["documentManagementReducer"].totalDocumentSpaceAvailable
  );
  const getDocumentCategories = useCallback(() => {
    switch (attachedLevelName?.toUpperCase()) {
      case documentAttachmentLevelEnums.audit:
      case documentAttachmentLevelEnums.auditCase:
      case documentAttachmentLevelEnums.auditEntity:
        return documentCategoryList.internalWorkflowDocumentCategories;
      case documentAttachmentLevelEnums.externalAudit:
      case documentAttachmentLevelEnums.externalAuditCase:
      case documentAttachmentLevelEnums.externalAuditOCR:
        return documentCategoryList.externalWorkflowDocumentCategories;
      case documentAttachmentLevelEnums.coder:
      case documentAttachmentLevelEnums.provider:
        return documentCategoryList.maintenanceWorkflowDocumentCategories;
      case documentAttachmentLevelEnums.task:
        return getDocumentCategoriesForTask(props.taskAttachmentLevel);
      default:
        return [];
    }
  }, [
    documentAttachmentLevelEnums,
    attachedLevelName,
    props.taskAttachmentLevel,
    documentCategoryList,
  ]);
  const getDocumentCategoriesForTask = useCallback(
    (taskAttachmentLevel) => {
      switch (taskAttachmentLevel?.toUpperCase()) {
        case taskAttachLevelEnums.audit:
        case taskAttachLevelEnums.auditCase:
        case taskAttachLevelEnums.auditEntity:
          return documentCategoryList.internalWorkflowDocumentCategories;
        case taskAttachLevelEnums.externalAudit:
        case taskAttachLevelEnums.externalAuditCase:
          return documentCategoryList.externalWorkflowDocumentCategories;
        case taskAttachLevelEnums.coder:
        case taskAttachLevelEnums.provider:
          return documentCategoryList.maintenanceWorkflowDocumentCategories;
        default:
          return [];
      }
    },
    [taskAttachLevelEnums, documentCategoryList]
  );

  useEffect(() => {
    if (!totalDocumentSpaceAvailable)
      asyncAction.asyncOperationStart(
        GET_DOCUMENT_MANAGEMENT_CONFIG,
        attachedLevelName
      );
  }, []);

  const onDocumentSelectionChange = useCallback(
    (
      e: ValueChangedEvent,
      documentDataToSave: Array<typeof initialDocumentDataToSave>
    ) => {
      let documentDataToSaveCopy =
        documentDataToSave != null ? [...documentDataToSave] : [];
      let getDocumentPromise = Promise.resolve<any>(null);
      if (e.value && e.value.length > 0) {
        e.value.forEach((file, index) => {
          let documentDataItemToSave = null;
          if (isPopupModeUploadToOCR)
            documentDataItemToSave = documentDataToSaveCopy[0];
          else
            documentDataItemToSave = documentDataToSaveCopy?.find(
              (x) => x.selectedFile === file
            );
          if (!documentDataItemToSave) {
            documentDataItemToSave = {
              ...initialDocumentDataToSave,
            };
            documentDataToSaveCopy.push(documentDataItemToSave);
          }

          documentDataItemToSave.documentName = file.name
            .split(".")
            .slice(0, -1)
            .join(".");
          documentDataItemToSave.selectedFile = file;
          documentDataItemToSave.originalFileName = file.name;
          documentDataItemToSave.fileSize = file.size;

          if (isPopupModeUploadToOCR) {
            getDocumentPromise = getNumPages(file);
            dispatch({ type: SHOW_LOADER });
          }

          getDocumentPromise = getDocumentPromise
            .then((pdfPageCount) => {
              //insert document page count
              if (pdfPageCount != null) {
                if (pdfPageCount > 100) {
                  mdaeNotify({
                    message: "Maximum PDF Page Size for OCR is 100 pages",
                    messageType: NOTIFY_MESSAGE_TYPE.ERROR,
                  });
                  documentUploaderInstance.reset();
                  return;
                }
                dispatch({
                  type: SET_CASE_SEARCH_DOCUMENT_DATA,
                  data: {
                    ocrDocumentData: {
                      ...documentDataItemToSave,
                      documentName: documentDataItemToSave.documentName,
                      pdfPageCount,
                    },
                  },
                });
              }
            })
            .catch((ex) => {
              mdaeNotify({
                message: "Please select a valid PDF document",
                messageType: NOTIFY_MESSAGE_TYPE.ERROR,
              });
              documentUploaderInstance.reset();
              first(documentDataToSaveCopy).selectedFile = null;
            })
            .finally(() => {
              dispatch({ type: HIDE_LOADER });
              setTimeout(() => {
                dispatch({ type: HIDE_LOADER });
              }, 1000);
            });
        });
        getDocumentPromise.then(() => {
          documentDataToSaveCopy.forEach((x) => addCommonProperties(x));
          dispatch({
            type: SET_DOCUMENT_DATA_TO_SAVE,
            data: { documentDataToSave: documentDataToSaveCopy },
          });
        });

        documentDataGridInstance?.refresh();
      } else {
        if (first(documentDataToSaveCopy)) {
          first(documentDataToSaveCopy).selectedFile = null;
          dispatch({
            type: SET_DOCUMENT_DATA_TO_SAVE,
            data: { documentDataToSave: documentDataToSaveCopy },
          });
        }
      }
    },
    [documentDataGridInstance, isPopupModeUploadToOCR, documentUploaderInstance]
  );

  const onDocumentNameChanged = useCallback(
    (e) => {
      if (isPopupModeUploadToOCR && e.event)
        dispatch({
          type: SET_CASE_SEARCH_DOCUMENT_DATA,
          data: {
            ocrDocumentData: {
              ...ocrDocumentData,
              documentName: e.value,
            },
          },
        });
    },
    [isPopupModeUploadToOCR, documentUploaderInstance, isPopupModeUploadToOCR]
  );

  const calculateFileSize = useCallback(
    (documentDataToSave: Array<typeof initialDocumentDataToSave>) => {
      return documentDataToSave.reduce(
        (sum, nextvalue) =>
          sum +
          (nextvalue.selectedFile && nextvalue.uploadProgress !== 100
            ? nextvalue.selectedFile.size
            : 0),
        0
      );
    },
    []
  );
  const getFileSizeString = useCallback(() => {
    const fileSizeInBytes = calculateFileSize(documentDataToSave);
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    const fileSizeInKB = fileSizeInBytes / 1024;
    let fileSizeString = "";
    if (fileSizeInMB > 0 || fileSizeInKB > 0) {
      if (fileSizeInMB >= 1) {
        fileSizeString = Math.round(fileSizeInMB) + " MB";
      } else {
        if (fileSizeInKB >= 1) {
          fileSizeString = Math.round(fileSizeInKB) + " KB";
        } else {
          fileSizeString = Math.round(fileSizeInBytes) + " B";
        }
      }
    } else {
      fileSizeString = "0 KB";
    }
    return fileSizeString;
  }, [documentDataToSave]);
  const onDocumentUploaderInitialized = (e) => {
    setDocumentUploaderInstance(e.component);
  };

  const refreshDocumentList = useCallback(() => {
    asyncAction.asyncOperationStart(GET_DOCUMENTS, {
      attachedLevelId: attachedLevelId,
      attachedLevelName: attachedLevelName,
      showForCoderReviewInd: includeNonAuditLevelDocumentInd,
      isManagerView: false,
      uniqueId: props.uniqueId,
    });
  }, [attachedLevelId, attachedLevelName, includeNonAuditLevelDocumentInd]);

  const abortUpload = useCallback(
    (documentDataToSave) => {
      documentUploaderInstance.abortUpload(documentDataToSave.selectedFile);
      setUploadProgress(
        dispatch,
        documentDataToSave[documentUploadDatagridKeyExpr],
        -1
      );
    },
    [documentUploaderInstance]
  );

  const uploadDocument = useCallback(
    (documentDataToSave) => {
      return new Promise<void>((resolve, reject) => {
        documentDataToSave.attachedLevelId = attachedLevelId;
        documentDataToSave.attachedLevelName = attachedLevelName;
        setUploadProgress(
          dispatch,
          documentDataToSave[documentUploadDatagridKeyExpr],
          0
        );
        let tags = null;
        if (isPopupModeUploadToOCR) {
          documentDataToSave.sendDocumentToOCR = true;
          if (!documentDataToSave.saveToDocumentManagement) {
            documentDataToSave.attachedLevelName =
              documentAttachmentLevelEnums.externalAuditOCR;
          }
          documentDataToSave.ocrMetricTrackingData = {
            pageCount: ocrDocumentData.pdfPageCount,
            eaAuditId,
          };

          // Add tags here
          tags = {
            clientId: clientId.toString(),
          };
        }
        dispatch({ type: SHOW_LOADER });
        callOperation(SAVE_USER_DOCUMENTS, documentDataToSave)
          .then(function(response) {
            dispatch({ type: HIDE_LOADER });
            if (response.isSaved) {
              setUploadProgress(
                dispatch,
                documentDataToSave[documentUploadDatagridKeyExpr],
                10
              );
              if (isPopupModeUploadToOCR)
                dispatch({
                  type: SET_CASE_SEARCH_DOCUMENT_DATA,
                  data: {
                    ocrDocumentData: {
                      ...ocrDocumentData,
                      documentId: response.documentId,
                    },
                  },
                });
              const setUploadProgressWithDocumentKey = (value) => {
                setUploadProgress(
                  dispatch,
                  documentDataToSave[documentUploadDatagridKeyExpr],
                  value
                );
              };
              documentUploadFramework
                .NewInstance()
                .uploadFile(
                  documentDataToSave.selectedFile,
                  response.s3ObjectName,
                  response.documentId,
                  documentDataToSave.documentName,
                  documentDataToSave.attachedLevelName,
                  documentDataToSave.attachedLevelId,
                  dispatch,
                  tags,
                  Boolean(isPopupModeUploadToOCR),
                  setUploadProgressWithDocumentKey
                )
                .then((isFileUploaded) => {
                  if (isFileUploaded) {
                    setUploadProgress(
                      dispatch,
                      documentDataToSave[documentUploadDatagridKeyExpr],
                      90
                    );
                    setTimeout(() => {
                      setUploadProgress(
                        dispatch,
                        documentDataToSave[documentUploadDatagridKeyExpr],
                        100
                      );
                    }, 500);
                    mdaeNotfy({
                      message:
                        documentDataToSave.documentName +
                        " uploaded Succesfully!",
                      messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
                    });
                    resolve();
                    if (!props.doNotRefreshDataGrid) refreshDocumentList();

                    if (isPopupModeUploadToOCR) {
                      dispatch({
                        type: SET_S3_OBJECT_NAME,
                        data: response.s3ObjectName,
                      });
                      initiateOCRPolling(dispatch, asyncAction, {
                        s3ObjectName: response.s3ObjectName,
                      });
                    }
                  }
                  if (isPopupModeUploadToOCR)
                    toggleEditDocumentPopupVisible(dispatch, false);
                })
                .catch(() => {
                  abortUpload(documentDataToSave);
                  reject();
                });
            }
            else{
              mdaeNotify({
                message: response.error,
                messageType: NOTIFY_MESSAGE_TYPE.ERROR,
              });
              abortUpload(documentDataToSave);
            }
          })
          .catch(() => {
            abortUpload(documentDataToSave);
            reject();
          });
      });
    },
    [
      isPopupModeUploadToOCR,
      documentAttachmentLevelEnums,
      ocrDocumentData,
      clientId,
      props.doNotRefreshDataGrid,
      includeNonAuditLevelDocumentInd,
      documentUploaderInstance,
    ]
  );

  const validateSelectedDocumentToUpload = useCallback(
    (documentData: typeof initialDocumentDataToSave) => {
      let isUnsupportedFileExtension = false;
      const fileNameSplit = documentData.selectedFile.name.split(".");
      if (fileNameSplit.length === 1) isUnsupportedFileExtension = true;
      else {
        const fileExtension = "." + fileNameSplit[fileNameSplit.length - 1];
        if (
          !Object.keys(allowedFilesMap).includes(fileExtension?.toLowerCase())
        )
          isUnsupportedFileExtension = true;
      }
      if (isUnsupportedFileExtension) {
        return {
          isValidRow: false,
          warningIconTitle: "File Type not supported",
        };
      }
      const fileSizeInMB = documentData.selectedFile.size / (1024 * 1024);
      const fileSizeLeft = Math.round(totalDocumentSpaceAvailable * 1024);
      if (fileSizeInMB > fileSizeLeft) {
        return {
          isValidRow: false,
          warningIconTitle:
            "Your organization only has " +
            getReleventFileSizeUnitFromBytes(fileSizeLeft * 1024 * 1024) +
            " of storage left. Your document is " +
            getReleventFileSizeUnitFromBytes(documentData.selectedFile.size) +
            " and cannot be uploaded at this time.",
        };
      }

      if (fileSizeInMB > 500) {
        return {
          isValidRow: false,
          warningIconTitle: "File size can not be greater than 500 MB.",
        };
      }
      if (documentData.documentName != undefined) {
        if (!isDocumentNameValid(documentData.documentName)) {
          return {
            isValidRow: false,
            warningIconTitle:
              "This document contains invalid special characters. Please rename the document by removing the special characters or using one of the following: & $ @ = ! - _ . ) ( '",
          };
        }
      }
      return { isValidRow: true, warningIconTitle: "" };
    },
    [totalDocumentSpaceAvailable]
  );

  const uploadFileHandler = useCallback(
    (file, setUploadProgress) => {
      const currentDocumentDataToSave = documentDataToSave.find(
        (x) => x.selectedFile === file
      );
      return uploadDocument(currentDocumentDataToSave);
    },
    [documentDataToSave]
  );

  const onFileUploaderValueChanged = useCallback(
    (e) => {
      onDocumentSelectionChange(e, documentDataToSave);
    },
    [documentDataToSave]
  );

  const fileUploaderValidationcallback = useCallback(
    (e) => {
      if (
        e.value?.length === 0 ||
        first(documentDataToSave)?.selectedFile == null
      )
        return true;
      for (let index = 0; index < documentDataToSave.length; index++) {
        const documentDataItemToSave = documentDataToSave[index];
        const { isValidRow } = validateSelectedDocumentToUpload(
          documentDataItemToSave
        );
        if (!isValidRow) return false;
      }
      return true;
    },
    [documentDataToSave, validateSelectedDocumentToUpload]
  );

  const selctedDocumentsValidationcallback = useCallback(() => {
    return selctedAttachItemCount > 0;
  }, [selctedAttachItemCount]);

  const nameRequiredinMyComputerValidationCallaback = useCallback(() => {
    const documentDataToSaveCopy = first(documentDataToSave);
    if (uploadDocumentCount > 0 && documentDataToSaveCopy.selectedFile != null)
      return documentDataToSaveCopy?.documentName != null;
    else return true;
  }, [documentDataToSave, uploadDocumentCount]);

  const onDocumentDatagridRowRemoved = useCallback(
    (e) => {
      dispatch({
        type: REMOVE_SELECTED_FILE,
        data: {
          file: e.data.documentUploadDatagridKeyExpr,
        },
      });
      documentUploaderInstance.removeFile(e.data.selectedFile);
    },
    [documentUploaderInstance]
  );

  const onDocumentDatagridSaving = useCallback((e: any) => {
    if (e.changes?.length > 0 && first<any>(e.changes)?.type === "insert") {
      e.changes.forEach((item) => {
        addCommonProperties(item.data);
      });
    } else if (
      e.changes?.length > 0 &&
      first<any>(e.changes)?.type === "update"
    ) {
      e.changes.forEach((item) => {
        item.data["updatedOn"] = new Date();
      });
    }
    dispatch({
      type: SAVE_DOCUMENT_UPLOAD_GRID_DATA,
      data: {
        change: e.changes[0],
      },
    });
  }, []);
  const onDocumentDatagridInitialized = useCallback((e) => {
    setDocumentDataGridInstance(e.component);
  }, []);
  const onDocumentDatagridAllowUpdating = useCallback(({ row }) => {
    return row.data.uploadProgress === null || row.data.uploadProgress === -1;
  }, []);
  const onDocumentDatagridAllowDeleting = useCallback(({ row }) => {
    return (
      row.data.uploadProgress === null ||
      row.data.uploadProgress === 100 ||
      row.data.uploadProgress === -1
    );
  }, []);
  const onDocumentDatagridActionCellRender = useCallback(
    (e) => {
      const { isValidRow, warningIconTitle } = validateSelectedDocumentToUpload(
        e.data
      );
      if (!isValidRow) {
        return (
          <div style={{ marginLeft: 10 }}>
            <i
              className="dx-icon warning-red"
              title={warningIconTitle}
              style={{ height: 18 }}
            ></i>
          </div>
        );
      } else if (e.data.uploadProgress === -1)
        return (
          <div style={{ marginLeft: 10 }}>
            <i
              className="fa fa-refresh"
              title={"Upload failed, please hit Save to retry failed documents"}
              style={{ fontSize: 20, color: "#d41c1c" }}
            ></i>
          </div>
        );
      else if (e.data.uploadProgress !== null && e.data.uploadProgress !== 100)
        return (
          <div title="Upload in Progress">
            <CircularProgressWithLabel
              value={e.data.uploadProgress}
              width={30}
              height={30}
              fontSize={10}
            />
          </div>
        );
      else if (e.data.uploadProgress === 100)
        return (
          <div style={{ marginLeft: 10 }}>
            <i
              className="fa fa-check-circle"
              title={"Upload Complete"}
              style={{ color: "green", fontSize: 20 }}
            ></i>
          </div>
        );
      else return <></>;
    },
    [validateSelectedDocumentToUpload]
  );

  const documentFieldValueChangeHandler = useCallback((e) => {
    documentFieldValueChangeEvent(
      dispatch,
      e.component.option("name"),
      e.value
    );
  }, []);

  return (
    <>
      {" "}
      {[DOCUMENT_POPUP_MODE.UPLOAD, DOCUMENT_POPUP_MODE.OCR_UPLOAD].includes(
        documentPopupMode
      ) && (
        <div style={{ display: "flex" }}>
          <MdaeFileUploader
            id={"btnFileUploader"}
            disabled={!isDocumentPopupSafeToClose}
            visible={[
              DOCUMENT_POPUP_MODE.UPLOAD,
              DOCUMENT_POPUP_MODE.OCR_UPLOAD,
            ].includes(documentPopupMode)}
            multiple={!isPopupModeUploadToOCR}
            showFileList={isPopupModeUploadToOCR}
            maxFileSize={524288000}
            onValueChanged={onFileUploaderValueChanged}
            uploadFile={uploadFileHandler}
            abortUpload={() => Promise.resolve()}
            onInitialized={onDocumentUploaderInitialized}
            defaultValue={[]}
            allowedFileExtensions={Object.keys(allowedFilesMap)}
            accept={Object.values(allowedFilesMap).join(",")}
          >
            <Validator validationGroup={documentValidationGroup}>
              <CustomRule
                message={""}
                reevaluate={true}
                validationCallback={fileUploaderValidationcallback}
              />
              <CustomRule
                validationCallback={selctedDocumentsValidationcallback}
                reevaluate={true}
                message={""}
              />
            </Validator>
          </MdaeFileUploader>

          <div>
            <label
              id="file-size-limit"
              style={{
                color:
                  documentDataToSave.reduce(
                    (sum, nextvalue: any) =>
                      sum + parseFloat(nextvalue.fileSize),
                    0
                  ) /
                    (1024 * 1024) >
                  500
                    ? "red"
                    : "green",
                width: "150px",
                marginTop: "20px",
              }}
            >
              {getFileSizeString()} of 500 MB
            </label>
          </div>
        </div>
      )}
      {[DOCUMENT_POPUP_MODE.UPLOAD].includes(documentPopupMode) && (
        <div>
          <DataGrid
            id="grdDocumentUpload"
            keyExpr={documentUploadDatagridKeyExpr}
            dataSource={documentDataToSave}
            onRowRemoved={onDocumentDatagridRowRemoved}
            onSaving={onDocumentDatagridSaving}
            onInitialized={onDocumentDatagridInitialized}
          >
            <Editing
              mode="cell"
              allowUpdating={onDocumentDatagridAllowUpdating}
              allowDeleting={onDocumentDatagridAllowDeleting}
              allowAdding={false}
              confirmDelete={false}
            />
            <Paging defaultPageSize={5} />
            <Pager
              showPageSizeSelector={true}
              showNavigationButtons={true}
              allowedPageSizes={[5, 10]}
              showInfo={true}
            />
            <Column width={40} type="buttons" visibleIndex={0}>
              <Button name="delete" cssClass={"delete-action-icon"} />
            </Column>
            <Column
              allowSorting={false}
              allowFiltering={false}
              fixed={true}
              allowEditing={false}
              allowExporting={false}
              allowResizing={false}
              allowReordering={false}
              alignment="center"
              cssClass="document-upload-validation-column-max-width"
              cellRender={onDocumentDatagridActionCellRender}
            ></Column>
            <Column
              caption={"File Name"}
              dataField={"documentName"}
              showEditorAlways={true}
            ></Column>
            <Column
              editorOptions={{ placeholder: "Choose a Category" }}
              caption={"Category"}
              dataField={"documentCategoryId"}
              showEditorAlways={true}
            >
              <Lookup
                displayExpr={"documentCategoryName"}
                valueExpr={"documentCategoryId"}
                dataSource={getDocumentCategories()}
              />
            </Column>
            <Column
              width={70}
              caption={"File Type"}
              calculateDisplayValue={(e) =>
                getFileExtension(e.selectedFile?.name)
              }
            ></Column>
            <Column
              width={80}
              caption={"File Size"}
              allowEditing={false}
              calculateDisplayValue={(e) =>
                getReleventFileSizeUnitFromBytes(e.selectedFile.size)
              }
            ></Column>
          </DataGrid>
        </div>
      )}
      {[DOCUMENT_POPUP_MODE.EDIT, DOCUMENT_POPUP_MODE.OCR_UPLOAD].includes(
        documentPopupMode
      ) && (
        <>
          <div>
            <MdaeCheckBox
              id="chkSaveToDocumentManagement"
              visible={isPopupModeUploadToOCR}
              value={first(documentDataToSave)?.saveToDocumentManagement}
              onValueChanged={documentFieldValueChangeHandler}
              name={"saveToDocumentManagement"}
              text="Upload to Audit Level Document Management"
            />
          </div>
          <div className={"widget-separation-margin-top"}>
            <MdaeTextBox
              required
              id={"txtDocumentName"}
              mdaeTextBoxTitle={"File Name"}
              disabled={currentSelectedRowData.isDocInEsmdSubmission}
              value={first(documentDataToSave)?.documentName}
              onValueChanged={(e) => {
                if (e.event) {
                  onDocumentNameChanged(e);
                  documentFieldValueChangeHandler(e);
                }
              }}
              name={"documentName"}
            >
              <Validator validationGroup="documentValidationGroup">
                <CustomRule
                  message={"Name is required"}
                  reevaluate={true}
                  validationCallback={
                    nameRequiredinMyComputerValidationCallaback
                  }
                />
                <CustomRule
                  validationCallback={(e) => isDocumentNameValid(e.value)}
                  message={documentValidationMessage}
                />
              </Validator>
            </MdaeTextBox>
          </div>
          <div className={"widget-separation-margin-top"}>
            <MdaeSelectBox
              id={"ddlDocumentCategory"}
              mdaeDropDownBoxTitle={"Category"}
              displayExpr={"documentCategoryName"}
              valueExpr={"documentCategoryId"}
              dataSource={getDocumentCategories()}
              value={first(documentDataToSave)?.documentCategoryId}
              name={"documentCategoryId"}
              onValueChanged={documentFieldValueChangeHandler}
            ></MdaeSelectBox>
          </div>
        </>
      )}
    </>
  );
};

export default EditDocumentPopup;
